<template>
  <div style="height:auto;min-height:740px">
    <!-- 选择框 -->
    <div class="home screenbox">
      <ul class="screen clearfix" style="padding-bottom:0px">
        <li class="fl">
          <div class="wrap">
            <treeselect
              v-model="value"
              :options="options"
              :multiple="false"
              :show-count="true"
              :disable-branch-nodes="true"
              @input="valueInput(value)"
              placeholder="请选择数据表"
            />
          </div>
        </li>
        <li class="fl">
          <div class="wrap">
            <el-select v-model="country" @change="countryInput" filterable placeholder="请选择" size="medium">
              <el-option
                v-for="item in countries"
                :key="item.id"
                :label="item.label"
                :value="item.id"
                placeholder="请选择国家"
              ></el-option>
            </el-select>
          </div>
        </li>
        <li class="fl">
          <div class="wrap">
            <el-select v-model="year" @change="yearInput" filterable placeholder="请选择" size="medium">
              <el-option
                v-for="item in years"
                :key="item.id"
                :label="item.label"
                :value="item.id"
                placeholder="请选择时间"
              ></el-option>
            </el-select>
          </div>
        </li>
      </ul>
      <ul class="screen clearfix" style="padding:0px 5px">
       <li class="w50 fl">
         <router-link :to="{ path:`/powerIndicators?${this.optionsId}`}" target="_blank" class="state">
          <span></span>
          <a>指标解释</a>
         </router-link>
       </li>
      </ul>
    </div>
    <!-- 表格 -->
    <div class="mapbox">
      <div class="bj_white2 home">
        <el-table :data="tableData" :row-class-name="tableRowClassName" border style="width: 100%">
          <el-table-column
            v-for="item in columns"
            :key="item.id"
            :prop="item.label"
            :label="item.label"
            min-width="200"
          ></el-table-column>
          <!-- width="180" -->
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, total, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { api } from "@/require/api";

export default {
  components: {
    Treeselect
  },
  data() {
    return {
      value: null,
      options: [],
      country: "",
      countries: [],
      year: "",
      years: [],
      columns: [],
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      optionsId:''
    };
  },
  created() {
    this.GISgetTableTree();
  },
  methods: {
    async GISgetTableTree() {
      const { code, data } = await api.get(
        "politicalDbController/getDataTableTree"
      );
      if (code === 0) {
        this.options = data;
        this.value = data[0].children[0].id;
      }
    },

    /* 初始即触发 */
    valueInput(val) {
      this.currentPage = 1
      this.optionsId = val
      this.GISgetTableInfos(val);
    },
    async GISgetTableInfos(val) {
      const { code, data } = await api.get(
        "politicalDbController/getTableInfos",
        { tableId: val }
      );
      if (code === 0) {
        this.years = data.times;
        this.countries = data.countrys;
        this.columns = data.columns;
        data.countrys.length === 0 ? (this.country = ''):(this.country = data.countrys[0].id)
        data.times.length === 0 ? (this.year = ''):(this.year = data.times[0].id)
      }
      this.GISgetTableDatas();
    },

    /* 数据改变即触发 */
    countryInput(event, item) {
      this.currentPage = 1
      this.GISgetTableDatas();
    },
    yearInput() {
      this.currentPage = 1
      this.GISgetTableDatas();
    },

    // 表格
    async GISgetTableDatas() {
      const { code, data } = await api.get(
        "politicalDbController/getTableDatas",
        {
          tableId: this.value,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          year: this.year,
          country: this.country
        }
      );
      if (code === 0) {
        this.tableData = data.dataList;
        this.total = data.total;
      }
    },
    handleSizeChange(pageSizeVal) {
      this.pageSize = pageSizeVal;
      this.GISgetTableDatas();
    },
    handleCurrentChange(currentPageVal) {
      this.currentPage = currentPageVal;
      this.GISgetTableDatas();
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex%2) === 1) {
        return "success-row";
      }
      return "rowa";
    }
  }
};
</script>

<style lang='less' scoped>
// 选择框
.screenbox {
  height: 90px;
  box-sizing: border-box;
  .screen {
    box-sizing: border-box;
    padding: 5px;
    li {
      width: 33.33%;
      padding: 5px 5px;
      .wrap {
        height: 34px;
        border: 0;
        .el-select {
          display: block;
        }
      }
    }
  }
}
// 指标说明
.state{
  width: 100%;
  height: 34px;
  background: #fff;
  border: 1px solid #d2d6df;
  color: #606266;
  display: block;
  padding: 6px 10px;
  border-radius: 3px;
  text-align: left;
}
.state:hover{
  border: 1px solid #227fcc;
  color: #227fcc;
}
.state span{
  background: url(../../assets/imgs/state.png) no-repeat center;
  background-size: 100%;
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align:middle
}
// 表格
.mapbox {
  padding: 5px 10px;
  box-sizing: border-box;
  .bj_white2 {
    background: #fff;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);
  }
}
// 表格
/deep/.el-pagination__total {
  margin-left: 10px !important;
}
/deep/.el-table .cell {
  line-height: 21px;
  // word-break: keep-all;
  // overflow: visible;
}
/deep/.el-table th{
  background: #dfefff;
}
/deep/.el-table--border th{
  border-right: 1px solid #fff;
}
/deep/.el-table .success-row {
  background: #f4f4f4;
}
/deep/.el-table thead{
  color: #666666;
}
/deep/.el-table__body-wrapper{
  height: 500px;
  overflow: auto;
}
</style>